import React from 'react';

import { Table } from '@devexpress/dx-react-grid-material-ui';

import { SENSOR_SOURCE_TYPES } from '../../helpers/sensors';

const SensorSourcingCell = ({ row, ...props }) => {
    const children = [];
    Object.entries(row.sensorSourcing)
        .forEach(([sourceKey, value]) => {
            if (!value) {
                return;
            }
            children.push(SENSOR_SOURCE_TYPES[sourceKey]);
        });
    return (
        <Table.Cell row={row} {...props}>
            {children.join(', ')}
        </Table.Cell>
    );
};

export default SensorSourcingCell;
